module.exports = __webpack_public_path__ + "img/20250429.39b12759.png";